import { useState } from "react";
import {
  FACULTY_PREPEND,
  FACULTY_ROUTER_URL,
  ROUTER_URL,
  STUDENT_PREPEND,
  STUDENT_ROUTER_URL,
} from "../../constants/routerUrl";
import { logoutUser } from "../../action/common/keyClaokActionCreator";
import { connect } from "react-redux";
import { IAdminUserInfo } from "../../models/common/IUserProfile";
import { NavLink, useLocation } from "react-router-dom";
import { UserTypes } from "../../models/dashboard/adminDashboard";
import { collegeType } from "../../constants/collegeType";

const CollegeAdminMenu = (props: IAdminUserInfo) => {
  const [] = useState(ROUTER_URL.COLLEGE_ADMIN_DASHBOAD);
  const { user, logout } = props;
  const location = useLocation();
  const isActive = (path: string) => location.pathname.startsWith(path);

  return (
    <>
      <ul className="accordion-menu">
        <li>
          <NavLink
            to={ROUTER_URL.COLLEGE_DETAILS}
            className={({ isActive }) =>
              isActive ? "menu-title active" : "menu-title"
            }
          >
            <img src="assets/images/icon/graduation.svg" alt="" />
            University Management
          </NavLink>
        </li>

        {user.currentCollege.managementType !=
          collegeType.universityAdministration && (
          <>
            <li>
              <NavLink
                to={STUDENT_ROUTER_URL.BUTTON_PRIORITY}
                state={{ userRole: UserTypes.Student }}
                className={
                  isActive(STUDENT_PREPEND) ? "menu-title active" : "menu-title"
                }
              >
                <img src="assets/images/icon/user.svg" alt="" />
                Student Settings
              </NavLink>
            </li>
            <li>
              <NavLink
                to={FACULTY_ROUTER_URL.BUTTON_PRIORITY}
                state={{ userRole: UserTypes.Faculty }}
                className={
                  isActive(FACULTY_PREPEND) ? "menu-title active" : "menu-title"
                }
              >
                <img src="assets/images/icon/people.svg" alt="" />
                Faculty Settings
              </NavLink>
            </li>
          </>
        )}

        <li>
          <NavLink
            to={ROUTER_URL.FEEDBACK}
            className={({ isActive }) =>
              isActive ? "menu-title active" : "menu-title"
            }
          >
            <img src="assets/images/icon/feedback.svg" alt="" />
            Feedback
          </NavLink>
        </li>
        <li className="menu-item">
          <NavLink
            to={ROUTER_URL.ADMIN_SETTINGS}
            className={({ isActive }) =>
              isActive ? "menu-title active" : "menu-title"
            }
          >
            <img src="assets/images/icon/setting.svg" alt="" />
            Settings
          </NavLink>
        </li>
        <li className="menu-item">
          <NavLink
            to={ROUTER_URL.INSTRUCTIONS}
            className={({ isActive }) =>
              isActive ? "menu-title active" : "menu-title"
            }
          >
            <img src="/assets/images/icon/help.svg" alt="" /> Help
          </NavLink>
        </li>
      </ul>
      {/* {configUserType != ConfigUserTypes.College &&
        configUserType != ConfigUserTypes.Department && (
          <AdminDashbordMasters userType={configUserType} />
        )}
      {configUserType == ConfigUserTypes.College && <CollegeIndex />}
      {configUserType == ConfigUserTypes.Department && <DepartmentIndex />} */}
      <div className="poweredby">
        <a
          href="https://www.buduportal.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="/assets/images/budu.png" alt="" />
          Powered by Budu Portal{" "}
        </a>
        <p className="version">Version 2.0.0</p>
        <p className="copyrights">
          &copy; 2025 Budu Portal. All rights reserved.
        </p>
      </div>
    </>
  );
};
const mapDispatchToProps = {
  logout: () => logoutUser(),
};

function mapStateToProps(state: any) {
  return {
    currentRole: state.userDetails.userProfileData?.currentRole,
    user: state.userDetails.userProfileData,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CollegeAdminMenu);
